import { create } from 'zustand';
import type { SyncStatus } from '../offline/db';
import type { Conflict } from '../offline/syncEngine';

interface SyncState {
  statusByEntity: Record<string, SyncStatus>;
  conflicts: Conflict[];
  setStatus: (entity: string, s: SyncStatus) => void;
  addConflict: (c: Conflict) => void;
  clearConflict: (mutationId: string) => void;
}

export const useSyncStore = create<SyncState>((set) => ({
  statusByEntity: {},
  conflicts: [],
  setStatus: (entity, s) => set((st) => ({ statusByEntity: { ...st.statusByEntity, [entity]: s } })),
  addConflict: (c) => set((st) => ({ conflicts: [...st.conflicts, c] })),
  clearConflict: (id) => set((st) => ({ conflicts: st.conflicts.filter((c) => c.mutationId !== id) })),
}));
